<!-- SignUp Form Section -->

<div class="w-100 d-center">
  <p-progressSpinner *ngIf="loading"></p-progressSpinner>
</div>

<section [hidden]="signupSuccess" *ngIf="!loading">
  <form [formGroup]="myForm" (ngSubmit)="onSubmit()" novalidate>
    <div class="card-scroll">
      <div class="row">
        <div class="col-lg-4">
          <label class="block text-900 font-medium mb-2 ms-label-view" for="fName">{{ "First Name" | translator }}
          </label>
          <input type="text" id="fName" placeholder="{{ 'Type the first name' | translator }}"
            pattern="[\u0600-\u06FF\s]+" formControlName="fName" pInputText class="w-full mb-3 ms-input-view"
            [disabled]="type == 'MISSING'" />
          <div class="error" *ngIf="
              myForm.controls['fName'].invalid &&
              (myForm.controls['fName'].dirty ||
                myForm.controls['fName'].touched)
            ">
            <div *ngIf="myForm.controls['fName'].errors?.['required']">
              {{ "The name is required" | translator }}
            </div>
            <div *ngIf="myForm.controls['fName'].errors?.['pattern']">
              {{ "Please write in Arabic" | translator }}
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <label class="block text-900 font-medium mb-2 ms-label-view" for="mName">{{ "the second name" | translator
            }}</label>
          <input type="text" id="mName" placeholder="{{ 'Type the second name' | translator }}"
            pattern="[\u0600-\u06FF\s]+" formControlName="mName" pInputText class="w-full mb-3 ms-input-view"
            [disabled]="type == 'MISSING'" />
          <div class="error" *ngIf="
              myForm.controls['mName'].invalid &&
              (myForm.controls['mName'].dirty ||
                myForm.controls['mName'].touched)
            ">
            <div *ngIf="myForm.controls['mName'].errors?.['required']">
              {{ "The name is required" | translator }}
            </div>
            <div *ngIf="myForm.controls['mName'].errors?.['pattern']">
              {{ "Please write in Arabic" | translator }}
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <label class="block text-900 font-medium mb-2 ms-label-view" for="lName">{{ "family name" | translator
            }}</label>
          <input type="text" id="lName" placeholder="{{ 'Type the last name' | translator }}"
            pattern="[\u0600-\u06FF\s]+" formControlName="lName" pInputText class="w-full mb-3 ms-input-view"
            [disabled]="type == 'MISSING'" />
          <div class="error" *ngIf="
              myForm.controls['lName'].invalid &&
              (myForm.controls['lName'].dirty ||
                myForm.controls['lName'].touched)
            ">
            <div *ngIf="myForm.controls['lName'].errors?.['required']">
              {{ "The name is required" | translator }}
            </div>
            <div *ngIf="myForm.controls['lName'].errors?.['pattern']">
              {{ "Please write in Arabic" | translator }}
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <label class="block text-900 font-medium mb-2 ms-label-view" for="email">{{ "E-mail address" | translator
            }}</label>
          <input type="email" id="email" placeholder="{{ 'Type the email address' | translator }}"
            formControlName="email" pInputText class="w-full mb-3 text-start ms-input-view"
            [disabled]="type == 'MISSING' || formUserProfile" />
          <div class="error" *ngIf="
              myForm.controls['email'].invalid &&
              (myForm.controls['email'].dirty ||
                myForm.controls['email'].touched)
            ">
            <div *ngIf="myForm.controls['email'].errors?.['required']">
              {{ "Email required" | translator }}
            </div>
            <div *ngIf="myForm.controls['email'].errors?.['email']">
              {{ "Email is invalid" | translator }}
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <label class="block text-900 font-medium mb-2 ms-label-view" for="phone">{{ "Mobile Phone Number" | translator
            }}</label>
          <input type="text" id="phone" placeholder="--------- 966 00" formControlName="phone" pInputText
            class="w-full mb-3 ms-input-view" [disabled]="type == 'MISSING'" />
          <div class="error" *ngIf="
              myForm.controls['phone'].invalid &&
              (myForm.controls['phone'].dirty ||
                myForm.controls['phone'].touched)
            ">
            <div *ngIf="myForm.controls['phone'].errors?.['required']">
              {{ "Mobile phone number is required" | translator }}
            </div>
            <div *ngIf="myForm.controls['phone'].errors?.['pattern']">
              {{ "Invalid mobile phone number" | translator }}
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <label class="block text-900 font-medium mb-2 ms-label-view" for="national_id">{{ "National Identity" |
            translator }}</label>
          <input type="text" id="national_id" placeholder="xxxxxxxxxx" formControlName="national_id" pInputText
            class="w-full mb-3 ms-input-view" [disabled]="type == 'MISSING'" />
          <div class="error" *ngIf="
              myForm.controls['national_id'].invalid &&
              (myForm.controls['national_id'].dirty ||
                myForm.controls['national_id'].touched)
            ">
            <div *ngIf="myForm.controls['national_id'].errors?.['required']">
              {{ "National ID is required" | translator }}
            </div>
            <div *ngIf="myForm.controls['national_id'].errors?.['pattern']">
              {{ "The national ID is invalid" | translator }}
            </div>
          </div>
        </div>
        <div class="col-lg-6 ppp-dropdown">
          <label class="block text-900 font-medium mb-2 ms-label-view" for="gender">{{ "Sex" | translator }}</label>
          <p-dropdown id="gender" [options]="gender" placeholder="{{ 'Choose gender' | translator }}"
            formControlName="gender" class="ppp-dropdown sstarabic w-100" [disabled]="type == 'MISSING' || formUserProfile">
            <ng-template let-item pTemplate="item">
              <i [ngClass]="item.icon"></i>
              {{ item.label }}
            </ng-template>
          </p-dropdown>
        </div>
        <div class="col-lg-6 ppp-dropdown">
          <label class="block text-900 font-medium mb-2 ms-label-view" for="city">{{ "City" | translator }}
          </label>
          <p-dropdown id="city" [options]="city" optionValue="value" optionLabel="label"
            placeholder="{{ 'Select city' | translator }}"
            formControlName="location" (onChange)="changeCityFilter()" class="ppp-dropdown sstarabic w-100">
            <ng-template let-item pTemplate="item">
              <i [ngClass]="item.icon"></i>
              {{ item.label }}
            </ng-template>
          </p-dropdown>
          <div class="error" *ngIf="
              myForm.controls['location'].invalid &&
              (myForm.controls['location'].dirty ||
                myForm.controls['location'].touched)
            ">
            <div *ngIf="myForm.controls['location'].errors?.['required']">
              {{ "city required" | translator }}
            </div>
          </div>
        </div>

        <div *ngIf="type != 'SIGNUP' && type != 'MISSING' && !hideRole && !formUserProfile" class="col-lg-6 ppp-dropdown">
          <label class="block text-900 font-medium mb-2 ms-label-view" for="role">{{ "The role" | translator }}</label>
          <p-dropdown appendTo="body" id="ous" [options]="roles" placeholder="{{ 'Select the role' | translator }}"
            [filter]="true" [showClear]="true" formControlName="role" class="ppp-dropdown sstarabic w-100">
            <ng-template let-item pTemplate="item">
              {{ item.label }}
            </ng-template>
          </p-dropdown>
        </div>

        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-4 my-2" *ngFor="let ous of selectedOus; let i = index">
              <div class="ou-boxes">
                <div class="d-flex justify-content-between mt-1">
                  <span class="ou-list-hover color-grey v4-font-600">{{
                    ous?.type?.name
                    }}</span>
                  <button *ngIf="!formUserProfile" class="close-btn" (click)="deleteOU(i)">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <div class="ou-list">
                  <span class="color-grey"> {{ ous?.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="!formUserProfile" class="col-12 ppp-dropdown" [hidden]="filtredOus.length <= 0">
          <label class="block text-900 font-medium mb-2 ms-label-view OUDD" for="city">{{
            selectionName }}</label>
          <p-dropdown #OUDD styleClass="w-100 p-dropdown-items-wrapper" appendTo="body"
            (onChange)="handleOU($event.value._id); OUDD.resetFilter();" [options]="filtredOus" optionLabel="name"
            [filter]="true" [showClear]="true" filterBy="name" placeholder="{{'select' | translator}} {{
              selectionName
            }}">
          </p-dropdown>
        </div>

        <div *ngIf="!hidePermissionSelection && !formUserProfile && type !== 'SIGNUP'" class="col-12 mt-1">
          <!-- <label class="block text-900 font-medium mb-2 ms-label-view">
            {{ "What permissions are required" | translator }}
          </label> -->
          <!-- <div class="d-flex gap-2">
            <div class="d-flex align-items-center">
              <p-checkbox class="color-grey gap-2 check-ui"
                [binary]="true"
                [value]="'ASSESSMENT'" 
                [formControl]="permissionsForm.controls['ASSESSMENT']"
                (onChange)="onPermissionChange('ASSESSMENT', $event.checked)"
                label="{{ 'Assessment' | translator }}">
              </p-checkbox>
            </div>
            <div class="flex align-items-center check-ui">
              <p-checkbox class="color-grey gap-2"
                [binary]="true"
                [value]="'SURVEY'" 
                [formControl]="permissionsForm.controls['SURVEY']"
                (onChange)="onPermissionChange('SURVEY', $event.checked)"
                label="{{ 'Survey' | translator }}">
              </p-checkbox>
            </div>
            <div class="flex align-items-center check-ui">
              <p-checkbox  class="color-grey gap-2"
                [binary]="true"
                [value]="'TRAINING'" 
                [formControl]="permissionsForm.controls['TRAINING']"
                (onChange)="onPermissionChange('TRAINING', $event.checked)"
                label="{{ 'Training' | translator }}">
              </p-checkbox>
            </div>
          </div> -->
        </div>
        

        <div class="d-flex flex-column align-items-start justify-content-start gap-2 mt-2" *ngIf="type == 'SIGNUP'" >
            <re-captcha id="recaptcha" formControlName="recaptcha"
            (notloaded)="captchaNotLoaded = true"
            [class.is-invalid]="myForm.get('recaptcha')?.invalid && (myForm.get('recaptcha')?.dirty || myForm.get('recaptcha')?.touched)">
            </re-captcha>
            <div *ngIf="captchaNotLoaded" class="alert alert-warning d-flex flex-row align-items-center">
              <span>{{ "Captcha was not loaded due to internet connectivity. Please click the icon to reload." | translator }}</span>
              <div class="d-flex">
                <div class="tabel-circle-btn" [pTooltip]="'Reload Captcha' | translator" (click)="reloadCaptcha()"><i class="pi pi-refresh"></i></div>
              </div>
            </div>
          <div
            *ngIf="myForm.get('recaptcha')?.invalid && (myForm.get('recaptcha')?.dirty || myForm.get('recaptcha')?.touched)"
            class="invalid-feedback">
            <div *ngIf="myForm.get('recaptcha')?.errors?.['required']">{{'are required'|translator}}</div>
          </div>
        </div>
      </div>
    </div>
    <p *ngIf="message" class="message">{{ message }}</p>
    <div class="px-2">
      <button [hidden]="type != 'CREATE' && type != 'SIGNUP'" type="submit"  pButton pRipple [disabled]="!myForm.valid"
        label="{{ 'construction' | translator }}" icon="pi pi-user-plus" class="w-full v4-login-btn"></button>
    </div>
    <span [hidden]="type != 'UPDATE' && type != 'MISSING'">
      <button type="submit" [disabled]="!myForm.valid" pButton pRipple label="{{ 'to update' | translator }}"
        icon="pi pi-user-edit" class="w-full v4-login-btn"></button>
    </span>
  </form>
</section>
<section [hidden]="!signupSuccess && type == 'SIGNUP'">
  <p class="center-alert  text-center">{{ this.message }}</p>
</section>